<div
  role="alert"
  [class]="'alert-' + style"
  [ngClass]="{'alert-container-sm': small,
     'alert-container' : displayedText || confirmationLabel || small || contentTpl,
      'ob1-alert-row' : alertRow}"
  [attr.data-e2e]="e2e"
  >
  @if (alertRow) {
    <div class="d-flex flex-column">
      <ng-container [ngTemplateOutlet]="alertHeader"></ng-container>
      <div class="alert-content">
        <ng-container [ngTemplateOutlet]="alertContent"></ng-container>
      </div>
    </div>
    <div class="alert-content">
      <ng-container [ngTemplateOutlet]="alertConfirm"></ng-container>
    </div>
  }
  @if (!alertRow) {
    <ng-container [ngTemplateOutlet]="alertHeader"></ng-container>
    @if ((displayedText || confirmationLabel) && !contentTpl) {
      <div class="alert-content">
        <ng-container [ngTemplateOutlet]="alertContent"></ng-container>
        <ng-container [ngTemplateOutlet]="alertConfirm"></ng-container>
      </div>
    } @else {
      @if (contentTpl) {
        <div [attr.data-e2e]="e2e + '-body'" class="alert-content">
          <ng-content></ng-content>
        </div>
      }
    }
  }
</div>

<ng-template #alertHeader>
  <p class="alert" [ngClass]="{'ob1-alert-normal' : alertNormal && !confirmationLabel}">
    <span class="alert-icon" [ngClass]="MaterialAlertIconClass[style]" aria-hidden="true"></span>
    <span class="ob1-alert-title" [attr.data-e2e]="e2e + '-title'">{{title}}</span>
  </p>
</ng-template>

<ng-template #alertContent>
  @for (item of displayedText; track item) {
    <p [ngClass]="{'alert-text' : !alertRow}">{{item}}</p>
  }
</ng-template>

<ng-template #alertConfirm>
  <!-- alert confirmation -->
  @if (confirmationLabel) {
    <!-- link confirmation style -->
    @if (isLinkConfirmationTemplate) {
      <a
        [attr.data-e2e]="e2e + '-confirmation'"
        [ecmDisabledAction]="isDisabledEclair"
        [href]="confirmationPath || ''"
        [ngClass]="{
                        'btn btn-secondary': confirmationStyle === 'button',
                        'o-link-arrow ob1-link-dark text-mw': confirmationStyle === 'link',
                        'o-link-small': small
                        }"
        (click)="materialAlertConfirm(); false"
        >
        {{confirmationLabel}}
      </a>
    } @else {
      <button
        class="btn btn-secondary"
        type="button"
        (click)="materialAlertConfirm()"
        [attr.data-e2e]="e2e + '-confirmation'"
        [ecmDisabledAction]="isDisabledEclair"
        >
        {{confirmationLabel}}
      </button>
    }
    <!-- button confirmation style -->
  }
</ng-template>

